<template>
  <div class="yhgProductShowAdd">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">返回产品展示列表</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws7" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="产品名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入产品名称" class="item-input" maxlength="15"></el-input>
        </el-form-item>
        <div style="display:flex;flex-wrap:wrap;margin-bottom:30px;">
          <el-form-item style="margin-right:30px;" label="产品展示图（前）" prop="imageUri1" ref="imageUri1">
            <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="fileListTemp1" :clears="clears"
              @outputFile="getFile1" @removeFile="removeFile1"></upload-file>
          </el-form-item>
          <el-form-item style="margin-right:30px;" label="产品展示图（后）" prop="imageUri2" ref="imageUri2">
            <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="fileListTemp2" :clears="clears"
              @outputFile="getFile2" @removeFile="removeFile2"></upload-file>
          </el-form-item>
        </div>
        <div style="display:flex;flex-wrap:wrap;margin-bottom:30px;">
          <el-form-item style="margin-right:30px;" label="产品展示图（左）" prop="imageUri3" ref="imageUri3">
            <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="fileListTemp3" :clears="clears"
              @outputFile="getFile3" @removeFile="removeFile3"></upload-file>
          </el-form-item>
          <el-form-item style="margin-right:30px;" label="产品展示图（右）" prop="imageUri4" ref="imageUri4">
            <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="fileListTemp4" :clears="clears"
              @outputFile="getFile4" @removeFile="removeFile4"></upload-file>
          </el-form-item>
        </div>
        <div style="display:flex;flex-wrap:wrap;margin-bottom:30px;">
          <el-form-item style="margin-right:30px;" label="产品展示图（上）" prop="imageUri5" ref="imageUri5">
            <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="fileListTemp5" :clears="clears"
              @outputFile="getFile5" @removeFile="removeFile5"></upload-file>
          </el-form-item>
          <el-form-item style="margin-right:30px;" label="产品展示图（下）" prop="imageUri6" ref="imageUri6">
            <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="fileListTemp6" :clears="clears"
              @outputFile="getFile6" @removeFile="removeFile6"></upload-file>
          </el-form-item>
        </div>
        <!-- 简介 -->
        <el-form-item label="产品简介" prop="content" class="editor-width">
          <el-input type="textarea" v-model="ruleForm.content" :rows="8" class="replyCon"></el-input>
        </el-form-item>
        <!-- 按钮 -->
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
          {{$t('lang.btn_save')}}
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:yhgProductShowAdd
   *@Description:御琥阁产品展示-编辑/新增
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import UploadFile from '../../components/upload_file.vue'
  export default {
    data() {
      return {
        clears: false, // 清空按钮
        accept: '.jpg, .jpeg, .png',
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
        saveData: '',
        isDisabled: true, // 保存的可点击
        isFlag: false, // 编辑:true 新增：false
        fileList1: [], // 文件列表
        fileList2: [], // 文件列表
        fileList3: [], // 文件列表
        fileList4: [], // 文件列表
        fileList5: [], // 文件列表
        fileList6: [], // 文件列表
        fileListTemp1: [],
        fileListTemp2: [],
        fileListTemp3: [],
        fileListTemp4: [],
        fileListTemp5: [],
        fileListTemp6: [],
        rules: {
          name: [{
            required: true,
            message: '请输入产品名称',
            trigger: 'blur'
          }],
          imageUri1: [{
            required: true,
            message: '请上传产品展示图',
            trigger: 'change'
          }],
          imageUri2: [{
            required: true,
            message: '请上传产品展示图',
            trigger: 'change'
          }],
          imageUri3: [{
            required: true,
            message: '请上传产品展示图',
            trigger: 'change'
          }],
          imageUri4: [{
            required: true,
            message: '请上传产品展示图',
            trigger: 'change'
          }],
          imageUri5: [{
            required: true,
            message: '请上传产品展示图',
            trigger: 'change'
          }],
          imageUri6: [{
            required: true,
            message: '请上传产品展示图',
            trigger: 'change'
          }],
          content: [{
            required: true,
            message: '请输入产品简介',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          id: '', // 序号
          type: 2, // 产品类型
          name: '', // 产品名称
          imageUri1: '', // 产品图片
          imageUri2: '', // 产品图片
          imageUri3: '', // 产品图片
          imageUri4: '', // 产品图片
          imageUri5: '', // 产品图片
          imageUri6: '', // 产品图片
          content: '', // 产品简介
        },
        tableData: [], // 全部小区
      }
    },
    computed: {

    },
    components: {
      'upload-file': UploadFile
    },
    destroyed() {
      window.localStorage.setItem('yhgProductform', JSON.stringify(this.ruleForm))
    },
    created() {
      // 判断编辑与新增
      this.isFlag = this.$route.query.flag
      if (window.localStorage.getItem('yhgProductform')) {
        this.ruleForm = JSON.parse(window.localStorage.getItem('yhgProductform'))
        this.fileList1 = JSON.parse(this.ruleForm.photoUrlBefore)
        this.fileListTemp1 = this.ruleForm.photoUrlBefore
        this.fileList2 = JSON.parse(this.ruleForm.photoUrlAfter)
        this.fileListTemp2 = this.ruleForm.photoUrlAfter
        this.fileList3 = JSON.parse(this.ruleForm.photoUrlLeft)
        this.fileListTemp3 = this.ruleForm.photoUrlLeft
        this.fileList4 = JSON.parse(this.ruleForm.photoUrlRight)
        this.fileListTemp4 = this.ruleForm.photoUrlRight
        this.fileList5 = JSON.parse(this.ruleForm.photoUrlUp)
        this.fileListTemp5 = this.ruleForm.photoUrlUp
        this.fileList6 = JSON.parse(this.ruleForm.photoUrlDown)
        this.fileListTemp6 = this.ruleForm.photoUrlDown
      } else {
        if (this.$route.query.object) {
          console.log(this.$route.query.object)
          // 编辑
          console.log('编辑')
          this.getData()
        } else {
          // 新增
          console.log('新增')
        }
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      getFile1(e) {
        this.ruleForm.imageUri1 = e
        this.$refs.imageUri1.clearValidate()
        this.isDisabled = false
      },
      removeFile1(e) {
        this.fileList1 = []
        this.ruleForm.imageUri1 = ''
        this.isDisabled = false
      },
      getFile2(e) {
        this.ruleForm.imageUri2 = e
        this.$refs.imageUri2.clearValidate()
        this.isDisabled = false
      },
      removeFile2(e) {
        this.fileList2 = []
        this.ruleForm.imageUri2 = ''
        this.isDisabled = false
      },
      getFile3(e) {
        this.ruleForm.imageUri3 = e
        this.$refs.imageUri3.clearValidate()
        this.isDisabled = false
      },
      removeFile3(e) {
        this.fileList3 = []
        this.ruleForm.imageUri3 = ''
        this.isDisabled = false
      },
      getFile4(e) {
        this.ruleForm.imageUri4 = e
        this.$refs.imageUri4.clearValidate()
        this.isDisabled = false
      },
      removeFile4(e) {
        this.fileList4 = []
        this.ruleForm.imageUri4 = ''
        this.isDisabled = false
      },
      getFile5(e) {
        this.ruleForm.imageUri5 = e
        this.$refs.imageUri5.clearValidate()
        this.isDisabled = false
      },
      removeFile5(e) {
        this.fileList5 = []
        this.ruleForm.imageUri5 = ''
        this.isDisabled = false
      },
      getFile6(e) {
        this.ruleForm.imageUri6 = e
        this.$refs.imageUri6.clearValidate()
        this.isDisabled = false
      },
      removeFile6(e) {
        this.fileList6 = []
        this.ruleForm.imageUri6 = ''
        this.isDisabled = false
      },
      // 业主通知编辑页面获取数据
      getData() {
        console.log('object', this.$route.query.object)
        // 这是用来双向绑定,由于字段名称不同，所以一一对应
        this.ruleForm.id = this.$route.query.object.id
        this.ruleForm.name = this.$route.query.object.title
        this.ruleForm.type = 2
        this.ruleForm.content = this.$route.query.object.info
        this.ruleForm.imageUri1 = this.$route.query.object.photoUrlBefore
        this.ruleForm.imageUri2 = this.$route.query.object.photoUrlAfter
        this.ruleForm.imageUri3 = this.$route.query.object.photoUrlLeft
        this.ruleForm.imageUri4 = this.$route.query.object.photoUrlRight
        this.ruleForm.imageUri5 = this.$route.query.object.photoUrlUp
        this.ruleForm.imageUri6 = this.$route.query.object.photoUrlDown
        this.fileList1.push({
          name: '',
          url: this.ruleForm.imageUri1
        })
        this.fileList2.push({
          name: '',
          url: this.ruleForm.imageUri2
        })
        this.fileList3.push({
          name: '',
          url: this.ruleForm.imageUri3
        })
        this.fileList4.push({
          name: '',
          url: this.ruleForm.imageUri4
        })
        this.fileList5.push({
          name: '',
          url: this.ruleForm.imageUri5
        })
        this.fileList6.push({
          name: '',
          url: this.ruleForm.imageUri6
        })
        this.fileListTemp1 = JSON.parse(JSON.stringify(this.fileList1))
        this.fileListTemp2 = JSON.parse(JSON.stringify(this.fileList2))
        this.fileListTemp3 = JSON.parse(JSON.stringify(this.fileList3))
        this.fileListTemp4 = JSON.parse(JSON.stringify(this.fileList4))
        this.fileListTemp5 = JSON.parse(JSON.stringify(this.fileList5))
        this.fileListTemp6 = JSON.parse(JSON.stringify(this.fileList6))
        console.log('getData', this.ruleForm)
        // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
        this.saveData = JSON.stringify(this.ruleForm)
      },
      // 返回上一级
      back() {
        this.$router.push({
          name: 'productShow'
        })
      },
      // 保存
      save(formName) {
        console.log('save', this.ruleForm)
        let params = {}
        if (this.isFlag) {
          params.Id = this.ruleForm.id
        }
        params.Title = this.ruleForm.name
        params.Type = this.ruleForm.type
        params.Info = this.ruleForm.content
        params.PhotoUrlBefore = this.ruleForm.imageUri1
        params.PhotoUrlAfter = this.ruleForm.imageUri2
        params.PhotoUrlLeft = this.ruleForm.imageUri3
        params.PhotoUrlRight = this.ruleForm.imageUri4
        params.PhotoUrlUp = this.ruleForm.imageUri5
        params.PhotoUrlDown = this.ruleForm.imageUri6
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            // 新增
            if (!params.Id) {
              this.$post('/nProduct', params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push({
                      name: 'productShow'
                    })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 编辑
              this.$patch(`/nProduct/${this.ruleForm.id}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push({
                      name: 'productShow'
                    })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 清空
      resetForm(formName) {
        this.$refs.ruleForm.clearValidate()
        this.clears = true
        this.fileList1 = []
        this.fileList2 = []
        this.fileList3 = []
        this.fileList4 = []
        this.fileList5 = []
        this.fileList6 = []
        this.ruleForm.name = ''
        this.ruleForm.content = ''
      },
    },

  }
</script>

<style lang="scss">
  .yhgProductShowAdd {
    .item-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }

    .replyCon {
      width: 600px;
    }
  }
</style>